import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { OelType } from 'src/app/models/oelType.model';
import { OelTypeService } from 'src/app/services/oel-type.service';
import { FormComponent, IFormDialogData } from 'src/app/shared/form/form.component';
import { NumberFormField, TextAreaFormField, TextFormField } from 'src/app/shared/form/formField.model';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ValueConversionService } from 'src/app/services/value-conversion.service';

@Component({
  standalone: false,
  selector: 'app-oel-type-dialog',
  templateUrl: './../../shared/form/form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss', './oel-type-dialog.component.scss']
})
export class OelTypeDialogComponent extends FormComponent<OelType> {

  constructor(
    dialogRef: MatDialogRef<OelTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
    oelTypeService: OelTypeService,
    protected injector: Injector,
    private valueConversionService: ValueConversionService
  ) {
    super(dialogRef, oelTypeService, data, 'OEL Type', injector);
  }

  ngOnInit(): void {
    this.isFormLoading = true;
    this.getEntity().subscribe({
      next: (entity) => {
        this.entity = entity;
        this.initModel();
        this.initFields();
        this.isFormLoading = false;
      },
      error: (error) => {
        this.toastService.showError(error);
        this.isFormLoading = false;
      }
    });
  }

  getNewObject(): OelType {
    return new OelType();
  }

  validate(): boolean {
    return true;
  }

  initModel() {
    if (!this.isAdd) {
      this.entity.referenceTimePeriod = this.valueConversionService.convertSecondsToHours(this.entity.referenceTimePeriod);
    }
  }

  initFields(): void {
    this.fields = [
      new TextFormField({
        property: nameOf<OelType>(x => x.name),
        name: 'Name'
      }),
      new TextAreaFormField({
        property: nameOf<OelType>(x => x.description),
        name: 'Description', required: false
      }),
      new NumberFormField({
        property: nameOf<OelType>(x => x.referenceTimePeriod),
        name: 'Reference Time Period [hours]', min: 0, max: 24
      }),
    ]
  }

  onBeforeSave(model: OelType): void {
    if (model.referenceTimePeriod !== undefined) {
      model.referenceTimePeriod = this.valueConversionService.convertHoursToSeconds(model.referenceTimePeriod);
    }
  }
}
